export const embedRoutes = [
  {
    path: '/embed',
    component: () => import('@/features/embed/EmbedView.vue'),
  },
  {
    path: '/embed-test',
    component: () => import('@/features/embed/embedTest/EmbedTestView.vue'),
  },
]
